(function (app) {

    /**
     * Interview Scheduling V2 Data Service - Manipulate all interview calendar related data
     * @namespace InterviewDataService
     *
     * Crafted By Rami Mustaklem
     */
    var InterviewDataService = function () {
        var self = this;

        var MINUTE = 60 * 1000;
        var HOUR = 60 * MINUTE;
        var DAY = 24 * HOUR;
        var dayFormat = "YYYY-MM-DD";
        var dayHourFormat = "YYYY-MM-DD HH:mm";
        var _emitter = JarEventEmitter.call(self);

        self.flatData = {
            slots: {},
            schedules: {},
            days: {}
        };
        self.interviewersList =[];

        var slotsChangedTimeout;

        var triggerSlotsChanged = function () {
            clearTimeout(slotsChangedTimeout);

            slotsChangedTimeout = setTimeout(function () {
                _emitter.trigger('slots_changed');
            }, 1);
        };

        self.setInterviewersList = function (interviewers) {
            var interviewersListChangedTimeout;

            self.interviewersList = angular.copy(interviewers);
            interviewersListChangedTimeout = setTimeout(function () {
                _emitter.trigger('interviewers_List_changed');
            }, 1);
        };

        self.reset = function (scheduleData) {
            self.flatData = {
                slots: {},
                schedules: {},
                days: {}
            };

            self.startDate = (scheduleData && scheduleData.start_date) || self.startDate;
        };

        self.hasFutureSlots = function () {

            var currentTime = moment().valueOf();
            var has = false;

            for (var s in self.flatData.slots) {
                if (self.flatData.slots[s]['start_time'] > currentTime) {
                    has = true;
                    break;
                }
            }

            return has;
        };

        self.validateSlots = function (windowMin, windowMax) {
            var slotsValidation = {};
            var checkSlots = function (slots) {
                for (var i in slots) {
                    var slot = slots[i];

                    if (moment(slot.start_time).isBefore(moment())) {
                        continue;
                    }

                    if (moment(slot.start_time).isBefore(windowMin) || moment(slot.end_time).isAfter(windowMax)) {
                        return true;
                    }
                }
            };

            slotsValidation.confirmedSlots = checkSlots(self.flatData.confirmedSlots);
            slotsValidation.slots = checkSlots(self.flatData.slots);

            return slotsValidation;
        };

        self.clearSlots = function () {

            /**
             * Get current time and current day and current week start
             */
            var currentTime = moment();
            var currentDay = moment().startOf('d');
            var currentWeekStart = getWeekStart(moment(), 'MON').startOf('day');

            /**
             * Loop all slots in flatData
             * Get slot time and if start time for slot is past then DO NOT DELETE
             */
            for (var s in self.flatData.slots) {
                if (self.flatData.slots[s]['start_time'] > currentTime.valueOf()) {
                    delete self.flatData.slots[s];
                }
            }

            /**
             * Loop all days in flatData
             * Get Today and future days
             * if future days then delete all slots
             * else if today then delete slots where start_time > currentTime
             */
            for (var d in self.flatData.days) {
                var dayDate = moment(d);
                if (dayDate.isAfter(currentDay)) {
                    self.flatData.days[d] = {};
                }

                if (dayDate.isSame(currentDay)) {
                    for (var $s in self.flatData.days[d]) {
                        if (self.flatData.days[d][$s]['start_time'] > currentTime.valueOf()) {
                            delete self.flatData.days[d][$s];
                        }
                    }
                }
            }

            /**
             Get schedule date and current week start
             if equal then DELETE slots that are in today's and current time's future
             else if future DELETE all slots
             else DO NOTHING
             */
            for (var c in self.flatData.schedules) {
                var scheduleStart = self.flatData.schedules[c]['start'];

                if (scheduleStart.isAfter(currentWeekStart)) {
                    for (var h in self.flatData.schedules[c]['columns']) {
                        self.flatData.schedules[c]['columns'][h]['slots'] = [];
                    }
                }

                if (scheduleStart.isSame(currentWeekStart)) {
                    var currentDayOfWeekInSchedule = parseInt((currentDay.valueOf() - currentWeekStart.valueOf()) / DAY);

                    var columnSlots = self.flatData.schedules[c]['columns'][currentDayOfWeekInSchedule]['slots'];
                    var slotsLength = columnSlots.length;
                    for (var slotIndex = slotsLength - 1; slotIndex >= 0; slotIndex--) {
                        var slot = self.flatData.schedules[c]['columns'][currentDayOfWeekInSchedule]['slots'][slotIndex];
                        if (slot.start_time > currentTime.valueOf()) {
                            self.flatData.schedules[c]['columns'][currentDayOfWeekInSchedule]['slots'].splice(slotIndex, 1);
                        }
                    }

                    currentDayOfWeekInSchedule++;

                    for (var m = currentDayOfWeekInSchedule; m < self.flatData.schedules[c]['columns'].length; m++) {
                        self.flatData.schedules[c]['columns'][m]['slots'] = [];
                    }
                }
            }

            triggerSlotsChanged();
        };

        self.deleteSlot = function (slot) {
            if (slot) {
                var slotId = slot.id;
                var oldDay = moment(slot.day).format(dayFormat);
                delete self.flatData['slots'][slotId];
                delete self.flatData['days'][oldDay][slotId];
                delete self.flatData['confirmedSlots'][slotId];
                triggerSlotsChanged();
            }
        };

        self.parseData = function (startDate, availableSlots, isCopy, confirmedApps) {
            var availableData = $.extend({}, availableSlots);
            confirmedApps = confirmedApps || [];

            var week = {};
            for (var w = 0; w < 7; w++) {
                var day = startDate.clone().add(w, 'd').format(dayFormat);
                week[day] = {};
            }

            var slots = {};
            for (var a in availableData) {
                var slot = availableData[a];
                var slotDay = moment(slot['start_time']).format(dayFormat);
                slot['start_time'] = moment(slot.start_time).valueOf();
                slot['end_time'] = moment(slot.end_time).valueOf();
                slot['day'] = moment(slotDay).valueOf();
                slots[slot['id']] = slot;
                week[slotDay] = week[slotDay] || {};
                week[slotDay][slot.id] = slot;
            }

            self.flatData.slots = isCopy? slots: $.extend(self.flatData.slots, (slots || {}));
            self.flatData.days = isCopy? week: $.extend(self.flatData.days, (week || {}));
            self.flatData.schedules = isCopy? {}: self.flatData.schedules || {};
            self.flatData.confirmedSlots = isCopy? {}: self.flatData.confirmedSlots || {};

            for (var i in confirmedApps) {
                var application = confirmedApps[i];

                if (application.interview_set_slot && self.flatData.slots[application.interview_set_slot.id]) {
                    self.flatData.slots[application.interview_set_slot.id].applications = self.flatData.slots[application.interview_set_slot.id].applications || [];
                    self.flatData.slots[application.interview_set_slot.id].applications.push(application);
                    self.flatData.confirmedSlots[application.interview_set_slot.id] = JSON.parse(JSON.stringify(self.flatData.slots[application.interview_set_slot.id]));
                }
            }

            self.startDate = startDate.clone() || self.startDate;
        };

        self.addSlot = function (slot) {
            if (slot) {
                var slotDay = moment(slot.day).format(dayFormat);
                self.flatData.slots[slot.id] = slot;
                self.flatData.days[slotDay] = self.flatData.days[slotDay] || {};
                self.flatData.days[slotDay][slot.id] = slot;
                triggerSlotsChanged();
            }
        };

        self.getShiftDay = function (shiftStartTime) {
            return moment(new Date(shiftStartTime)).format(dayFormat);
        };

        /**
         * Parse the availability slots for user whether they are available or booked and put them inside Array
         * @public
         * @type function
         * @memberOf InterviewDataService#parseAvailabilities
         * @param {Array} availabilities
         * @param {String} type="BOOKED"|"AVAILABLE"
         * @param {Number} forcePrint - if only 1 user available then I want to force show
         * @return undefined
         */
        self.parseAvailabilities = function (availabilities, type, forcePrint) {
            self.availabitlies = self.availabitlies || {};
            var userIds = [];

            for (var a in availabilities) {
                var user = availabilities[a];
                userIds.push(user.user_id);

                for (var u in user.slots) {
                    var availability = user.slots[u];
                    var slotDay = moment(availability.start_time).startOf().format(dayFormat);
                    availability.start_time = moment(availability.start_time).valueOf();
                    availability.end_time = moment(availability.end_time).valueOf();
                    availability.day = moment(availability.start_time).startOf().valueOf();
                    availability.user_id = user.user_id;
                    availability.user_ids = [user.user_id];
                    availability.type = type;
                    availability.count = 0;
                    availability.force = forcePrint;
                    availability.ids = [availability.id];
                    self.availabitlies[slotDay] = self.availabitlies[slotDay] || [];
                    self.availabitlies[slotDay].push(availability);
                }
            }

            var checkAllSlots = function () {
                for (var d in self.availabitlies) {
                    var day = self.availabitlies[d];

                    for (var i = 0; i < day.length; i++) {
                        // wait until i becomes > 0 so there will be at least 2 items
                        if (i > 0) {
                            // check if overlapping slots has the same type
                            if (self.doOverlap(day[i], day[i - 1]) && day[i]['type'] === day[i - 1]['type']) {
                                self.mergeOverlappingAvailabilities(day[i], day[i - 1], day);
                                // we have replaced the 2 merged slots with only 1
                                // so we would like to check if the new one also overlaps another
                                i = 0; // checkAllSlots();
                            }
                        }
                    }
                }
            };

            if (userIds.length > 1) {
                checkAllSlots();
            }
        };

        self.resetAvailabilities = function () {
            for (var i in self.availabitlies) {
                self.availabitlies[i] = [];
            }
        };

        /**
         * Returns a boolean if 2 slots cross each other's timing
         * @public
         * @type Function
         * @memberOf InterviewDataService#doOverlap
         * @param {Object} slot1 - New Slot
         * @param {Object} slot2 - Old Slot
         * @return {Boolean} doOverlap
         */
        self.doOverlap = function (slot1, slot2) {
            var slot1Start = slot1.start_time,
                slot2Start = slot2.start_time,
                slot1End = slot1.end_time,
                slot2End = slot2.end_time;

            if (
                (slot1Start < slot2Start && slot1End <= slot2Start) ||
                (slot1End > slot2End && slot1Start >= slot2End)
            ) {
                return false;
            }

            return true;
        };

        /**
         * If slots overlap each other in any way merge them and give me one final slot
         * @public
         * @type Function
         * @memberOf InterviewDataService#mergeOverlappingAvailabilities
         * @param {Object} slot1 - New Slot
         * @param {Object} slot2 - Old Slot
         * @param {Array} day - The day array containing the slots
         * @return {undefined}
         */
        self.mergeOverlappingAvailabilities = function (slot1, slot2, day) {
            var slot1Start = slot1.start_time,
                slot2Start = slot2.start_time,
                slot1End = slot1.end_time,
                slot2End = slot2.end_time,
                newSlotStart, newSlotEnd,
                slot1Index = _.findIndex(day, function (value) {
                    return value.id == slot1.id;
                }),
                slot2Index = _.findIndex(day, function (value) {
                    return value.id == slot2.id;
                });

            // if the type is AVAILABLE we need to take the INTERSECTION
            // else the type is BOOKED we need to take the UNION
            if (slot2.type === 'AVAILABLE') {
                newSlotStart = slot1Start > slot2Start ? slot1Start : slot2Start;
                newSlotEnd = slot1End > slot2End ? slot2End : slot1End;
            }
            else {
                newSlotStart = slot1Start > slot2Start ? slot2Start : slot1Start;
                newSlotEnd = slot1End > slot2End ? slot1End : slot2End;
            }

            var newSlot = {
                id: "temp_" + Date.now(),
                start_time: newSlotStart,
                end_time: newSlotEnd,
                day: slot2.day,
                type: slot2.type,
                user_id: slot2.user_id,
                user_ids: slot2.user_ids.concat(slot1.user_ids),
                count: slot2.count > slot1.count? slot2.count + 1: slot1.count +1,
                ids: slot2.ids.concat(slot1.ids)
            };

            if (slot1Index > -1) day.splice(slot1Index, 1);
            if (slot2Index > -1) day.splice(slot2Index, 1);
            day.push(newSlot);
        };

        self.excludeSlotsOutsideWindow = function (slots,windowMin, windowMax){
            return slots.filter(function (slot) {
                if (moment(slot.start_time).isBefore(moment())) {
                    return true; // Keep the slot if it's in the past
                }

                if (moment(slot.start_time).isBefore(windowMin) || moment(slot.end_time).isAfter(windowMax)) {
                    return false; // Exclude the slot that falls outside the window
                }

                return true; // Keep all other slots
            });
        };

        var generateUUID = function(startTime, endTime) {
            // Format the UUID as day_HHMMSS_HHMMSS
            return startTime.format('dddd') + '_' + startTime.format('HHmmss') + '_' + endTime.format('HHmmss');
        };

        self.getGeneratedUUIDSlots = function (slots){
            for (var i = 0; i < slots.length; i++) {
                var slot = slots[i];

                if (slot.recurrence_mode === 'NEVER_ENDS') {
                    var start_time = moment(slot.start_time);
                    var end_time = moment(slot.end_time);

                    var uuid = generateUUID(start_time, end_time);
                    slot.uuid = uuid;
                }
            }

            return slots;
        };

        self.retrieveSlotsToSave = function (windowMin, windowMax) {
            var slotsToSave = [];

            for (var j in self.flatData.days) {
                for (var s in self.flatData.days[j]) {
                    var newSlot = {
                        start_time: self.flatData.days[j][s].start_time,
                        end_time: self.flatData.days[j][s].end_time
                    };
                    if (self.flatData.days[j][s].recurrence_mode) {
                        newSlot.recurrence_mode = self.flatData.days[j][s].recurrence_mode;
                    }
                    slotsToSave.push(newSlot);
                }
            }

            for (var i in self.flatData.slots) {
                var newSlot = {
                    start_time: self.flatData.slots[i].start_time,
                    end_time: self.flatData.slots[i].end_time,
                };
                if (self.flatData.slots[i].recurrence_mode) {
                    newSlot.recurrence_mode = self.flatData.slots[i].recurrence_mode;
                }
                slotsToSave.push(newSlot);
            }

            for (var c in self.flatData.confirmedSlots) {
                var newSlot = {
                    start_time: self.flatData.confirmedSlots[c].start_time,
                    end_time: self.flatData.confirmedSlots[c].end_time,
                };
                if (self.flatData.confirmedSlots[c].recurrence_mode) {
                    newSlot.recurrence_mode = self.flatData.confirmedSlots[c].recurrence_mode;
                }
                slotsToSave.push(newSlot);
            }

            slotsToSave = _.uniq(slotsToSave, function (value) {
                return value.start_time && value.end_time;
            });

            if (windowMin && windowMax) {
                slotsToSave = self.excludeSlotsOutsideWindow(slotsToSave, windowMin, windowMax);
            }

            slotsToSave = self.getGeneratedUUIDSlots(slotsToSave);

            for (var s = 0; s < slotsToSave.length; s++) {
                if (s > 0) {
                    if (self.doOverlap(slotsToSave[s], slotsToSave[s - 1])) {
                        slotsToSave.splice(s, 1);
                        s = 0;
                        console.warn('There is overlapping between slots is not allowed on saving', s, slotsToSave);
                    }
                }
            }

            for (var n in slotsToSave) {
                slotsToSave[n]['start_time'] = Utils.getISODate(moment(slotsToSave[n]['start_time']).utc());
                slotsToSave[n]['end_time'] = Utils.getISODate(moment(slotsToSave[n]['end_time']).utc());
            }

            return slotsToSave;
        };
    };

    app.service('InterviewDataService', [
        function () {
            return new InterviewDataService();
        }
    ]);

})(angular.module('harriApp.interviewV2'));